<mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState">
        <mat-expansion-panel-header class="v-bg-primary">
            <mat-panel-title>
                <ng-container *ngIf="devMode; else elseTemplate">
                    <span class="text-light fs-5 f-bold">New Notification (Dev Mode)</span>
                </ng-container>
                <ng-template #elseTemplate>
                    <span class="text-light fs-5 f-bold">New Notification</span>
                </ng-template>

            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="newnotificationform">
            <div class="container pt-3">
                <mat-form-field>
                    <input matInput formControlName="title" placeholder="Title">
                </mat-form-field>
                <mat-form-field>
                    <textarea matInput formControlName="message" placeholder="Message"></textarea>
                </mat-form-field>
                <mat-form-field>
                    <input matInput formControlName="url" placeholder="URL">
                </mat-form-field>
                <!-- <div class="row">
                    <div class="col-sm">
                        <mat-form-field>
                            <input matInput formControlName="title" placeholder="Title">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="message" placeholder="Message">
                        </mat-form-field>
                        <h5>Roadbooks <button mat-icon-button color="accent" (click)="openDialog()">
                            <mat-icon>add</mat-icon>
                        </button></h5>
                    </div>
                    <div class="col-sm">
                        <mat-form-field>
                            <input matInput formControlName="code" placeholder="Activation Code">
                        </mat-form-field>
                        <div class="mt-1">
                            <mat-checkbox formControlName="visible">Visible</mat-checkbox>
                        </div>
                    </div>
                </div> -->

                <!-- <mat-list>
                    <mat-list-item *ngFor="let ri of currentRoadbooksIds">{{ roadbooksDict[ri]?.name }}</mat-list-item>
                </mat-list> -->
                <!-- <mat-chip-list>
                    <mat-chip *ngFor="let ri of currentRoadbooksIds" class="v-bg-primary text-light">{{ roadbooksDict[ri]?.name }}</mat-chip>
                </mat-chip-list> -->
            </div>
            <hr>
            <button (click)="saveNotification()" [disabled]="!newnotificationform.valid" class="btn btn-success">Save Notification</button>
            <button style="margin-left: 20px" (click)="reset()" class="btn btn-danger">Cancel</button>
        </form>
    </mat-expansion-panel>
</mat-accordion>
<mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre">
</mat-form-field>

<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="star" stickyEnd>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="editElemet(element)">
        <mat-icon>edit</mat-icon>
      </button>
                <!-- <button mat-icon-button (click)="removeElemet(element)">
        <mat-icon>delete</mat-icon>
      </button> -->
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.t}} </td>
        </ng-container>

        <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef> Message </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.m}} </td>
        </ng-container>
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row"> {{row.d.toDate() | date:'yyyy/MM/dd HH:mm:ss'}} </td>
        </ng-container>
        <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef> State </th>
            <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement === row ? null : row">
                <span [ngSwitch]="row.s">
                <mat-icon *ngSwitchCase="1" style="color: green">
                 done
                </mat-icon>
                <mat-icon *ngSwitchCase="2" style="color: red">
                cancel
                </mat-icon>
                <mat-icon *ngSwitchDefault style="color: rgb(38, 145, 245)">
                    schedule
                </mat-icon>
                </span>
            </td>
        </ng-container>
        <ng-container matColumnDef="visible">
            <th mat-header-cell *matHeaderCellDef> Visible </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox style="margin-left: 20px!important;" (change)="changeCheckBox(row, $event)" [checked]="row.v">
                </mat-checkbox>
            </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="6">
                <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="container" style="padding: 20px;">
                        <mat-card style="background-color: #e9e9e9">
                            <div><span style="font-weight: bold;">Id: </span>{{element.i}} </div>
                            <div><span style="font-weight: bold;">Title: </span>{{element.t}} </div>
                            <div><span style="font-weight: bold;">Message: </span>{{element.m}} </div>
                            <div><span *ngIf="element.u" style="font-weight: bold;">Url: </span>{{element.u}} </div>
                            <div><span style="font-weight: bold;">Date: </span>{{element.d.toDate() | date:'yyyy/MM/dd HH:mm:ss'}} </div>
                            <div><span style="font-weight: bold;">Visible: </span>{{(element.v) ? 'Yes' : 'No'}} </div>
                            <div style="display: flex; flex-direction: row;"><span style="font-weight: bold;">State: </span><span [ngSwitch]="element.s">
                                <mat-icon *ngSwitchCase="1" style="color: green">
                                 done
                                </mat-icon>
                                <mat-icon *ngSwitchCase="2" style="color: red">
                                cancel
                                </mat-icon>
                                <mat-icon *ngSwitchDefault style="color: rgb(38, 145, 245)">
                                    schedule
                                </mat-icon>
                                </span>
                            </div>
                            <div><span style="font-weight: bold;" *ngIf="element.e">Error: </span>{{element.e}} </div>
                        </mat-card>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100, 150]"></mat-paginator>
</div>